import { createCollectionHandleKeyMap } from 'config/collections/utils/create-collection-handle-key-map';
import { CollectionHandleKey } from 'config/collections/handles';
import { Region } from 'constants/shop';
import { CollectionFilter } from 'interfaces/collection-filter';

/**
 * Filter group order for collections without their own tag lists.
 * Tags for these groups come from ALL_AVAILABLE_FILTERS, so only the group set and
 * its order are collection specific.
 */
const FILTER_GROUP_ORDER: Partial<Record<CollectionHandleKey, Array<CollectionFilter>>> = {
  testCdpQa: ['sorts', 'line'],
  dogsWetFoodStorys: ['sorts', 'desires', 'age', 'sizes', 'line'],
  dogsWetFoodTest: ['special-desires', 'taste'],
  dogsSupplements: ['age'],
  dogsHealth: ['health-needs', 'nutritional-needs', 'line'],
  dogsAccessories: ['sorts', 'funktion'],
  dogsSmallBreeds: ['feed-type', 'sorts'],
  dogsBestsellers: ['sorts', 'nutritional-needs', 'age', 'hero-filter'],
  dogsSensitive: ['sorts', 'feed-type'],
  dogsPickyEaterUnaccented: ['sorts', 'feed-type'],
  dogsIntolerancesLp2: ['sorts', 'feed-type'],
  dogsAllMeatTypesLp: ['sorts', 'nutritional-needs', 'age', 'hero-filter'],
  dogsSugarFreeLp: ['sorts', 'nutritional-needs', 'age', 'feed-type'],
  dogsWetFoodLp: ['sorts', 'nutritional-needs', 'age'],
  dogsWetFoodLp2: ['sorts', 'desires', 'age', 'sizes', 'line'],
  dogsBarfLp2: ['sorts', 'desires', 'age', 'line'],
  dogsDryFoodLp: ['sorts', 'desires', 'age', 'sizes', 'line'],
  dogsBarfLp: ['sorts', 'nutritional-needs', 'age'],
  dogsSnacksLp: ['sorts', 'nutritional-needs', 'age'],
  dogsHealthLp: ['funktion'],
  dogsPuppyJuniorLp: ['feed-type', 'sorts'],
  dogsGrainFree: ['feed-type', 'sorts', 'nutritional-needs', 'age'],
  dogsHypoallergenicLp: ['sorts', 'nutritional-needs', 'age', 'feed-type'],
  dogsSupplementsLp: ['nutritional-needs', 'age'],
  dogsGrainFreeLp: ['sorts', 'desires', 'age', 'line'],
  dogsSeniorLp: ['sorts', 'feed-type'],
  catsAccessories: ['sorts'],
  catsUseYourBenefitLp: ['sorts', 'desires', 'age'],
  catsWetFoodLp: ['sorts', 'desires', 'age', 'line'],
  catsDryFoodLp: ['sorts', 'desires', 'age', 'line'],
  catsBarfLp: ['sorts', 'desires', 'line'],
  catsKittenLp: ['sorts', 'desires', 'line'],
  catsAllTexturesLp: ['sorts', 'desires', 'age', 'line'],
  catsAllMeatTypesLp: ['hero-filter', 'line', 'nutritional-needs', 'age', 'sorts'],
  catsHypoallergenicLp: ['sorts', 'age'],
  catsGrainFreeLp: ['sorts', 'desires', 'age'],
  bundles: ['species', 'sorts', 'nutritional-needs', 'age', 'desires', 'line'],
  catsPickyEaterLp1: ['feed-type', 'line', 'sorts'],
  catsNeutered: ['feed-type', 'line', 'sorts'],
  catsOutdoor: ['feed-type', 'line', 'sorts'],
  tawkrAssortment: ['species'],
  petsWetFood: ['species', 'sorts', 'desires'],
  petsDryFood: ['species', 'sorts', 'desires'],
  dogsTrialPacks: ['sorts', 'nutritional-needs', 'age'],
};

export const getFilterGroupOrderByHandle = (
  handle: string,
  region: Region = Region.DE
): Array<CollectionFilter> | undefined => {
  const key = createCollectionHandleKeyMap(handle, region);

  return key ? FILTER_GROUP_ORDER[key] : undefined;
};

export default FILTER_GROUP_ORDER;
